// import React, { useState } from 'react';

// import {
//   LayoutTemplate, Star, FileText, Bold, Italic, Smile, Send, X
// } from 'lucide-react';
// import InstanceMessageTemplateDocument from "../InstanceMessage/InstanceMessageTemplateDocument"
// import InstanceMessageTemplateWelcome from './InstanceMessageTemplateWelcome';

// const Templates = () => {
//   const [message, setMessage] = useState(`Hi John Doe,

// Just following up on the pending documents for Project Filing. Could you please share them at your earliest convenience?

// If you need any assistance or have questions, feel free to reach out.

// Best,
// Priya Sharma`);

//   const [selectedTemplate, setSelectedTemplate] = useState('followup');
//   const [IsopenModal, setIsOpenModal] = useState(false)
//   const [activeModalTemplate, setactiveModalTemplate] = useState(null)

//   const templates = [
//     {
//       id: 'followup',
//       title: 'Document Follow-up',
//       category: 'Follow-ups',
//       cardClass: 'templates-card-followup',
//       tags: ['Follow-up', 'Pending', 'Reminder'],
//       usage: 57,
//       saves: '2 min',
//       isPopular: true,
//       modalComponent: 'InstanceMessageTemplateDocument'
//     },
//     {
//       id: 'welcome',
//       title: 'Welcome Message',
//       category: 'Client Onboarding',
//       cardClass: 'templates-card-welcome',
//       tags: ['Welcome', 'Onboarding', 'Introduction'],
//       usage: 16,
//       saves: '6 min',
//       isPopular: false,
//       modalComponent: 'InstanceMessageTemplateWelcome'
//     },
//     {
//       id: 'payment',
//       title: 'Payment Reminder',
//       category: 'Invoice',
//       cardClass: 'templates-card-payment',
//       tags: ['Invoice', 'Payment', 'Reminder'],
//       usage: 35,
//       saves: '4 min',
//       isPopular: true,
//       modalComponent: 'InstanceMessageTemplatePayment'
//     }
//   ];

//   const handleTemplateClick = (templateId) => {
//     setSelectedTemplate(templateId);
//     const template = templates.find((t) => t.id === templateId)
//     setactiveModalTemplate(template)
//     setIsOpenModal(true)
//   };

//   const handleCloseModal = () => {
//     setIsOpenModal(false)
//     setactiveModalTemplate(null)
//   }

//   const handleUseTemplate = (templateContent) => {
//     setMessage(templateContent);
//     setIsOpenModal(false);
//     setactiveModalTemplate(null);
//   };

//   const handleCancelModal = () => {
//     setIsOpenModal(false);
//     setactiveModalTemplate(null);
//   };

//   // Function to render the modal based on active template
//   const renderModal = () => {
//     if (!activeModalTemplate) return null;

//     switch (activeModalTemplate.modalComponent) {
//       case 'InstanceMessageTemplateDocument':
//         return (
//           <InstanceMessageTemplateDocument
//             onClose={handleCloseModal}
//             onUse={handleUseTemplate}
//             onCancel={handleCancelModal}
//           />
//         );
//       case 'InstanceMessageTemplateWelcome':
//         return (
//           <div className="instance-message-template-document">
//             <div className="instance-message-template-header">
//               <h3 className='text-2xl text-gray-900 mb-2'>Welcome Message</h3>
//               <p className='text-sm text-gray-600'>Client Onboarding • Welcome</p>
//               <button onClick={handleCloseModal}>
//                 <X />
//               </button>
//             </div>
//             <InstanceMessageTemplateWelcome />
//             {/* <div className="bg-gray-50 rounded-xl p-6 mb-6 whitespace-pre-wrap text-gray-700">
//               <pre>
//                 {`Welcome to our platform, {{client_name}}! 🎉

// We're excited to have you on board. Our team is here to help you with all your {{service_type}} needs.

// Your dedicated account manager is {{manager_name}}, who will be your primary point of contact.

// Let's get started!

// Cheers,
// {{your_name}}`}
//               </pre>
//             </div> */}
//             <div className="instance-message-template-actions">
//               <button onClick={() => handleUseTemplate(`Hi {{client_name}},

// Welcome to {{company_name}}! We're excited to have you onboard.

// Let us know if you need any help getting started.

// Best,
// {{your_name}}`)}>
//                 Use Template
//               </button>
//               <button onClick={handleCancelModal}>Cancel</button>
//             </div>
//           </div>
//         );
//       case 'InstanceMessageTemplatePayment':
//         return (
//           <div className="instance-message-template-document">
//             <div className="instance-message-template-header">
//               <h3>Payment Reminder</h3>
//               <button onClick={handleCloseModal}>
//                 <X />
//               </button>
//             </div>
//             <div className="instance-message-template-preview">
//               <pre>
//                 {`Hi {{client_name}},

// This is a friendly reminder about invoice #{{invoice_number}} of that was due on {{due_date}}.

// Please let us know if you've already made the payment or if you need any clarification.

// Best,
// {{your_name}}`}
//               </pre>
//             </div>
//             <div className="instance-message-template-actions">
//               <button onClick={() => handleUseTemplate(`Hi {{client_name}},

// This is a friendly reminder about invoice #{{invoice_number}} of that was due on {{due_date}}.

// Please let us know if you've already made the payment or if you need any clarification.

// Best,
// {{your_name}}`)}>
//                 Use Template
//               </button>
//               <button onClick={handleCancelModal}>Cancel</button>
//             </div>
//           </div>
//         );
//       default:
//         return null;
//     }
//   };

//   return (
//     <section className="templates-section">
//       {/* Background blobs */}
//       <div className="templates-bg-blobs">
//         <div className="templates-blob templates-blob-1"></div>
//         <div className="templates-blob templates-blob-2"></div>
//       </div>

//       <div className="templates-container">
//         {/* Header */}
//         <div className="templates-header">
//           <div className="templates-badge">
//             <LayoutTemplate className="templates-badge-icon" />
//             <span className="templates-badge-text">Chat Templates</span>
//           </div>

//           <h2 className="templates-title">
//             Save Time with
//             <br />
//             <span className="templates-gradient-text">Smart Templates</span>
//           </h2>

//           <p className="templates-subtitle">
//             Pre-designed message templates for common scenarios. Send professional
//             messages in seconds.
//           </p>
//         </div>

//         {/* Templates Grid */}
//         <div className="templates-grid">
//           {templates.map((template) => (
//             <div
//               key={template.id}
//               className={`templates-card ${template.cardClass} ${selectedTemplate === template.id ? 'templates-card-selected' : ''}`}
//               onClick={() => handleTemplateClick(template.id)}
//             >
//               {/* Overlay */}
//               <div className="templates-card-overlay"></div>

//               {/* Content */}
//               <div className="templates-card-content">
//                 {template.isPopular && (
//                   <Star className="templates-star-icon" />
//                 )}

//                 <FileText className="templates-card-icon" />

//                 <h3 className="templates-card-title">{template.title}</h3>
//                 <p className="templates-card-category">{template.category}</p>

//                 <div className="templates-tags">
//                   {template.tags.map((tag, index) => (
//                     <span key={index} className="templates-tag">
//                       {tag}
//                     </span>
//                   ))}
//                 </div>

//                 <div className="templates-stats">
//                   <span>Used {template.usage} times</span>
//                   <span>Saves {template.saves}</span>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Modal Overlay - Add this section */}
//         {IsopenModal && (
//           <div className="modal-overlay">
//             <div className="modal-container">
//               {renderModal()}
//             </div>
//           </div>
//         )}

//         {/* Message Editor */}
//         <div className="templates-editor-container">
//           <div className="templates-editor-card">
//             {/* Editor Header */}
//             <div className="templates-editor-header">
//               <h3 className="templates-editor-title">Try Templates</h3>
//               <p className="templates-editor-subtitle">Type / to insert a template</p>
//             </div>

//             {/* Editor Body */}
//             <div className="templates-editor-body">
//               {/* Toolbar */}
//               <div className="templates-toolbar">
//                 <button className="templates-toolbar-btn">
//                   <Bold className="templates-toolbar-icon" />
//                 </button>
//                 <button className="templates-toolbar-btn">
//                   <Italic className="templates-toolbar-icon" />
//                 </button>
//                 <button className="templates-toolbar-btn">
//                   <Smile className="templates-toolbar-icon" />
//                 </button>
//                 <button className="templates-toolbar-btn templates-toolbar-btn-active">
//                   <LayoutTemplate className="templates-toolbar-icon" />
//                 </button>
//               </div>

//               {/* Textarea */}
//               <textarea
//                 value={message}
//                 onChange={(e) => setMessage(e.target.value)}
//                 placeholder="Type your message or use / for templates..."
//                 className="templates-textarea"
//                 rows="6"
//               />

//               {/* Send Button */}
//               <div className="templates-send-wrapper">
//                 <button className="templates-send-btn">
//                   <Send className="templates-send-icon" />
//                   Send Message
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Add CSS for modal */}
//       <style jsx>{`
//         .modal-overlay {
//           position: fixed;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background-color: rgba(0, 0, 0, 0.5);
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           z-index: 1000;
//           animation: fadeIn 0.3s ease;
//         }

//         .modal-container {
//           max-width: 600px;
//           width: 90%;
//           max-height: 80vh;
//           overflow-y: auto;
//           animation: slideUp 0.3s ease;
//         }

//         @keyframes fadeIn {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }

//         @keyframes slideUp {
//           from {
//             transform: translateY(20px);
//             opacity: 0;
//           }
//           to {
//             transform: translateY(0);
//             opacity: 1;
//           }
//         }
//       `}</style>
//     </section>
//   );
// };

// export default Templates;

import React, { useState } from "react";
import {
  LayoutTemplate,
  Star,
  FileText,
  Bold,
  Italic,
  Smile,
  Send,
  X,
} from "lucide-react";
import InstanceMessageTemplateDocument from "../InstanceMessage/InstanceMessageTemplateDocument";
import InstanceMessageTemplateWelcome from "./InstanceMessageTemplateWelcome";
import InstanceMessageTemplatePayment from "./InstanceMessageTemplatePayment";

const Templates = () => {
  const [message, setMessage] = useState(`Hi John Doe,

Just following up on the pending documents for Project Filing. Could you please share them at your earliest convenience?

If you need any assistance or have questions, feel free to reach out.

Best,
Priya Sharma`);

  const [selectedTemplate, setSelectedTemplate] = useState("followup");
  const [IsopenModal, setIsOpenModal] = useState(false);
  const [activeModalTemplate, setactiveModalTemplate] = useState(null);

  const templates = [
    {
      id: "followup",
      title: "Document Follow-up",
      category: "Follow-ups",
      cardClass: "templates-card-followup",
      tags: ["Follow-up", "Pending", "Reminder"],
      usage: 57,
      saves: "2 min",
      isPopular: true,
      modalComponent: "InstanceMessageTemplateDocument",
    },
    {
      id: "welcome",
      title: "Welcome Message",
      category: "Client Onboarding",
      cardClass: "templates-card-welcome",
      tags: ["Welcome", "Onboarding", "Introduction"],
      usage: 16,
      saves: "6 min",
      isPopular: false,
      modalComponent: "InstanceMessageTemplateWelcome",
    },
    {
      id: "payment",
      title: "Payment Reminder",
      category: "Invoice",
      cardClass: "templates-card-payment",
      tags: ["Invoice", "Payment", "Reminder"],
      usage: 35,
      saves: "4 min",
      isPopular: true,
      modalComponent: "InstanceMessageTemplatePayment",
    },
  ];

  const handleTemplateClick = (templateId) => {
    setSelectedTemplate(templateId);
    const template = templates.find((t) => t.id === templateId);
    setactiveModalTemplate(template);
    setIsOpenModal(true);
  };

  const handleCloseModal = () => {
    setIsOpenModal(false);
    setactiveModalTemplate(null);
  };

  const handleUseTemplate = (templateContent) => {
    setMessage(templateContent);
    setIsOpenModal(false);
    setactiveModalTemplate(null);
  };

  const handleCancelModal = () => {
    setIsOpenModal(false);
    setactiveModalTemplate(null);
  };

  // Function to render the modal based on active template
  const renderModal = () => {
    if (!activeModalTemplate) return null;

    switch (activeModalTemplate.modalComponent) {
      case "InstanceMessageTemplateDocument":
        return (
          <InstanceMessageTemplateDocument
            onClose={handleCloseModal}
            onUse={handleUseTemplate}
            onCancel={handleCancelModal}
          />
        );

      case "InstanceMessageTemplateWelcome":
        // ✅ CORRECT: Use the imported component directly with props
        return (
          <InstanceMessageTemplateWelcome
            onClose={handleCloseModal}
            onUse={handleUseTemplate}
            onCancel={handleCancelModal}
          />
        );

      case "InstanceMessageTemplatePayment":
        return (
          <InstanceMessageTemplatePayment
            onClose={handleCloseModal}
            onUse={handleUseTemplate}
            onCancel={handleCancelModal}
          />
        );

      default:
        return null;
    }
  };

  return (
    <section className="templates-section">
      {/* Background blobs */}
      <div className="templates-bg-blobs">
        <div className="templates-blob templates-blob-1"></div>
        <div className="templates-blob templates-blob-2"></div>
      </div>

      <div className="templates-container">
        {/* Header */}
        <div className="templates-header">
          <div className="templates-badge">
            <LayoutTemplate className="templates-badge-icon" />
            <span className="templates-badge-text">Chat Templates</span>
          </div>

          <h2 className="templates-title">
            Save Time with
            <br />
            <span className="templates-gradient-text">Smart Templates</span>
          </h2>

          <p className="templates-subtitle">
            Pre-designed message templates for common scenarios. Send
            professional messages in seconds.
          </p>
        </div>

        {/* Templates Grid */}
        <div className="templates-grid">
          {templates.map((template) => (
            <div
              key={template.id}
              className={`templates-card ${template.cardClass} ${selectedTemplate === template.id ? "templates-card-selected" : ""}`}
              onClick={() => handleTemplateClick(template.id)}
            >
              {/* Overlay */}
              <div className="templates-card-overlay"></div>

              {/* Content */}
              <div className="templates-card-content">
                {template.isPopular && <Star className="templates-star-icon" />}

                <FileText className="templates-card-icon" />

                <h3 className="templates-card-title">{template.title}</h3>
                <p className="templates-card-category">{template.category}</p>

                <div className="templates-tags">
                  {template.tags.map((tag, index) => (
                    <span key={index} className="templates-tag">
                      {tag}
                    </span>
                  ))}
                </div>

                <div className="templates-stats">
                  <span>Used {template.usage} times</span>
                  <span>Saves {template.saves}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Modal Overlay */}
        {IsopenModal && (
          <div className="modal-overlay">
            <div className="modal-container">{renderModal()}</div>
          </div>
        )}

        {/* Message Editor */}
        <div className="templates-editor-container">
          <div className="templates-editor-card">
            {/* Editor Header */}
            <div className="templates-editor-header">
              <h3 className="templates-editor-title">Try Templates</h3>
              <p className="templates-editor-subtitle">
                Type / to insert a template
              </p>
            </div>

            {/* Editor Body */}
            <div className="templates-editor-body">
              {/* Toolbar */}
              <div className="templates-toolbar">
                <button className="templates-toolbar-btn">
                  <Bold className="templates-toolbar-icon" />
                </button>
                <button className="templates-toolbar-btn">
                  <Italic className="templates-toolbar-icon" />
                </button>
                <button className="templates-toolbar-btn">
                  <Smile className="templates-toolbar-icon" />
                </button>
                <button className="templates-toolbar-btn templates-toolbar-btn-active">
                  <LayoutTemplate className="templates-toolbar-icon" />
                </button>
              </div>

              {/* Textarea */}
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Type your message or use / for templates..."
                className="templates-textarea"
                rows="6"
              />

              {/* Send Button */}
              <div className="templates-send-wrapper">
                <button className="templates-send-btn">
                  <Send className="templates-send-icon" />
                  Send Message
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CSS for modal */}
      <style jsx>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          animation: fadeIn 0.3s ease;
        }

        .modal-container {
          max-width: 600px;
          width: 90%;
          max-height: 80vh;
          overflow-y: auto;
          animation: slideUp 0.3s ease;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideUp {
          from {
            transform: translateY(20px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
      `}</style>
    </section>
  );
};

export default Templates;
